/**
 * Created by krusli on 2018/6/15.
 * 前端公共函数库
 */
(function ($, upNativeComm, dayjs) {
    var utils = {};
    var toastTimer = null;

    // 是否在APP端
    utils.isApp = window.navigator.userAgent.match(/uphybridsdk/i);
    // 是否在WX端
    utils.isWx = !!window.navigator.userAgent.match(/MicroMessenger/i);
    // 是否是ios终端
    utils.isIos = !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 是否为ios设备

    var b64c =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"; // base64 dictionary
    var b64u =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"; // base64url dictionary
    var b64pad = "=";

    /* base64_encode_data
     * Internal helper to encode data to base64 using specified dictionary.
     */
    function base64_encode_data(data, len, b64x) {
        var dst = "";
        var i;

        for (i = 0; i <= len - 3; i += 3) {
            dst += b64x.charAt(data.charCodeAt(i) >>> 2);
            dst += b64x.charAt(
                ((data.charCodeAt(i) & 3) << 4) | (data.charCodeAt(i + 1) >>> 4)
            );
            dst += b64x.charAt(
                ((data.charCodeAt(i + 1) & 15) << 2) |
                (data.charCodeAt(i + 2) >>> 6)
            );
            dst += b64x.charAt(data.charCodeAt(i + 2) & 63);
        }

        if (len % 3 == 2) {
            dst += b64x.charAt(data.charCodeAt(i) >>> 2);
            dst += b64x.charAt(
                ((data.charCodeAt(i) & 3) << 4) | (data.charCodeAt(i + 1) >>> 4)
            );
            dst += b64x.charAt((data.charCodeAt(i + 1) & 15) << 2);
            dst += b64pad;
        } else if (len % 3 == 1) {
            dst += b64x.charAt(data.charCodeAt(i) >>> 2);
            dst += b64x.charAt((data.charCodeAt(i) & 3) << 4);
            dst += b64pad;
            dst += b64pad;
        }

        return dst;
    }

    /* base64_encode
     * Encode a JavaScript string to base64.
     * Specified string is first converted from JavaScript UCS-2 to UTF-8.
     */
    function base64_encode(str) {
        var utf8str = unescape(encodeURIComponent(str));
        return base64_encode_data(utf8str, utf8str.length, b64c);
    }

    /* base64url_encode
     * Encode a JavaScript string to base64url.
     * Specified string is first converted from JavaScript UCS-2 to UTF-8.
     */
    function base64url_encode(str) {
        var utf8str = unescape(encodeURIComponent(str));
        return base64_encode_data(utf8str, utf8str.length, b64u);
    }


    var UPContent = function() {
        this.ret = "";
        this.retcnt = [];
        this.retlength = 0;
    };
    
    UPContent.prototype = {
        Set: function(k, v) {
            if ($.trim(k) == "") {
                alert("当前键对获取为NULL，请输入键值对");
                return;
            } else {
    
                if (typeof(v) == 'string') {
                    this.retcnt.push("\"" + k + "\":" + "\"" + v + "\"");
                } else if (typeof(v) == 'number') {
                    this.retcnt.push("\"" + k + "\":" + v);
                } else {
                    var _cnts = [];
                    $.each(v, function(n, m) {
                        if (typeof(m) == 'string') {
                            _cnts.push("\"" + n + "\":" + "\"" + m + "\"");
                        } else {
                            _cnts.push("\"" + n + "\":" + m);
                        }
                    });
                    this.retcnt.push("\"" + k + "\":{" + _cnts.join(',') + "}");
                }
                this.retlength++;
            }
        },
    
        Length: function() {
            return this.retlength;
        },
    
        Value: function() {
            return "[{" + this.retcnt.join(',') + "}]";
        }
    };
    /*
 * IOS函数桥接
 */
var IOS_Bridge = {

    callbacksCount: 1,
    callbacks: {},

    resultForCallback: function resultForCallback(callbackId, resultArray) {
        try {
            var callback = IOS_Bridge.callbacks[callbackId];
            if (!callback) {
                return;
            }
            callback.apply(null, resultArray);
        } catch (e) {
            alert(e);
        }
    },

    /*
     * functionName: 调用函数名称
     * args:json 格式参数
     * callback 回调函数名称
     * mob_funcname 类似UP
     */
    call: function call(args, funcID, frameID, callback, mob_funcname) {

        var hasCallback = callback && typeof callback == "function";
        var callbackId = hasCallback ? IOS_Bridge.callbacksCount++ : 0;

        if (hasCallback) {
            IOS_Bridge.callbacks[callbackId] = callback;
        }
        var iframe = document.createElement("IFRAME");

        iframe.setAttribute("src", "js-frame:" + callbackId + ";;" + frameID + ";;" + funcID + ";;" + args + ";;" + callback + ";;" + mob_funcname);
        //encodeURIComponent(JSON.stringify(args)));
        document.documentElement.appendChild(iframe);
        iframe.parentNode.removeChild(iframe);
        iframe = null;

    }
};
    /*
     * 移动平台调用Up_Callback
     * _callback_name： 回调函数名(js函数名)
     * _funid： 功能号
     * _parm： 请求参数对象 设置好的UPContent对象
     * _mob_formid： 移动平台用框架ID （非移动平台送''）送什么返回什么
     * _mob_ard_funcname：Android 平台用，后台功能模块名称 如'FuncID:'
     */
    function Up_Callback(_callback_name, _funid, _parm, _mob_formid, _mob_funcname) {
        if (utils.isIos) {
            IOS_Bridge.call(_parm == undefined ? '' : _parm.Value(), _funid, _mob_formid, _callback_name, _mob_funcname);
        // } else {
        //     window.up_java.Android_SendData(_parm == undefined ? '' : _parm.Length(), _parm == undefined ? '' : _parm.Value(), _funid, _mob_formid, _callback_name, _mob_funcname);
        }
    }


    // ajax请求
    utils.ajaxRequest = function (ajaxOpt) {
        var method = ajaxOpt.method || "POST";
        var timeout = ajaxOpt.timeout || 5000;

        $.ajax({
            type: method,
            url: ajaxOpt.url,
            timeout: timeout,
            data: JSON.stringify(ajaxOpt.data),
            contentType: "application/json;charset=utf-8",
            success: ajaxOpt.succCallback,
            error: ajaxOpt.errCallback,
        });
    };

    // ajax file 异步请求
    utils.ajaxFileRequest = function (ajaxOpt) {
        var method = ajaxOpt.method || "POST";
        var timeout = ajaxOpt.timeout || 15000;

        $.ajax({
            type: method,
            url: ajaxOpt.url,
            timeout: timeout,
            data: ajaxOpt.data,
            cache: false,
            processData: false, // 告诉jQuery不要去处理发送的数据
            contentType: false, // 告诉jQuery不要去设置Content-Type请求头
            success: ajaxOpt.succCallback,
            error: ajaxOpt.errCallback,
        });
    };

    /**
     * toast默认为2s显示
     * @param opt
     */
    utils.showToast = function (opt) {
        clearTimeout(toastTimer);
        var toastId = opt.id || "toast";
        var toastObj = $("#" + toastId);
        var toastTime = opt.timeout || 2000;
        // if (toastObj[0].className.indexOf('none') == -1) {
        //     return;
        // }
        toastObj.removeClass("none").text(opt.content);
        toastTimer = setTimeout(function () {
            toastObj.addClass("none");
        }, toastTime);
    };

    /**
     * 终端校验用户是否登录
     * @param handle
     * @param args
     */
    utils.checkLogin = function (handle, ...args) {
        upNativeComm.exec("UPUser.getUserInfo", {
            callback: (code, user) => {
                user = JSON.parse(user);
                if (user.uid && !user.isTourist) {
                    handle(...args);
                } else {
                    upNativeComm.exec("WebView.open", {
                        url: "upchina://user/login",
                    });
                }
            },
        });
    };
    /**
     * 终端校验用户是否登录
     * @param handle
     * @param args
     */
    utils.checkTouristLogin = function (handle, ...args) {
        upNativeComm.exec("UPUser.getUserInfo", {
            callback: (code, user) => {
                user = JSON.parse(user);
                if (user.uid) {
                    handle(...args);
                } else {
                    upNativeComm.exec("WebView.open", {
                        url: "upchina://user/login",
                    });
                }
            },
        });
    };
    /**
     * 跳转到终端登录页
     */
    utils.openUserLogin = function () {
        upNativeComm.exec("WebView.open", { url: "upchina://user/login" });
    };

    /**
     * 判断是否为对象且不为{}
     * @param obj
     * @returns {boolean}
     */
    utils.checkNullObject = function (obj) {
        if (obj && obj instanceof Object) {
            for (var i in obj) {
                if (obj.hasOwnProperty(i)) {
                    return false;
                }
            }
        }
        return true;
    };

    /**
     * 设置终端顶部菜单
     * 1:分享
     * 2:关注
     * 3: 已关注
     * 4: 私聊
     */
    utils.setNativeMenu = function (menuList) {
        menuList = menuList || [];
        upNativeComm["exec"]("WebView.setMenu", {
            items: menuList,
        });
    };

    /**
     * 设置终端顶部标题
     * 1:分享
     */
    utils.setNativeTitle = function (titleOpt) {
        titleOpt = titleOpt || { title: "详情页", subtitle: "", icon: "" };
        upNativeComm["exec"]("WebView.setTitle", titleOpt);
    };

    /**
     * 设置终端顶部背景颜色
     */
    utils.setNativeColor = function (color) {
        upNativeComm["exec"]("WebView.setTitleColor", color);
    };
    /**
     * 设置手机栏背景颜色
     */
    utils.setStatusBarColor = function (color) {
        upNativeComm["exec"]("WebView.setStatusBarColor", color);
    };

    /**
     * @description:设置终端标题字体颜色
     * @param {color:''}
     * @return {*}
     */
    utils.setNativeTitleColor = function (color) {
        upNativeComm["exec"]("WebView.setTitleTextColor", color);
    };

    /**
     * @description:设置返回栏颜色
     * @param {*} opt
     * @return {*}
     */
    utils.setNativeIconColor = function (opt = { black: false }) {
        upNativeComm["exec"]("WebView.setBackIconColor", opt);
    };
    /**
     * 时间格式化，与终端样式保持一致
     */
    utils.dateFormat = function (timestamps) {
        const date = dayjs(timestamps);
        const today = dayjs(
            `${dayjs().year()}-${dayjs().month() + 1
            }-${dayjs().date()} 00:00:00`
        );
        const yesterday = today.subtract(1, "day");
        const thisYear = dayjs(`${dayjs().year()}-1-1 00:00:00`);

        if (dayjs().diff(date, "minute") < 1) {
            return date.format("刚刚");
        } else if (dayjs().diff(date, "hour") < 1) {
            return date.format(dayjs().diff(date, "minute") + "分钟前");
        } else if (date.isAfter(today)) {
            return date.format("HH:mm");
        } else if (date.isAfter(yesterday)) {
            return date.format("昨天 HH:mm");
        } else if (date.isAfter(thisYear)) {
            return date.format("MM月DD日");
        } else {
            return date.format("YYYY年MM月DD日");
        }
    };

    // 特殊日期格式化 20180909 => 2018.09.09
    utils.speDateFormat = function (date) {
        return (
            String(date).slice(0, 4) +
            "." +
            String(date).slice(4, 6) +
            "." +
            String(date).slice(6, 8)
        );
    };
    // 日期格式化 20180909 => 9月9日
    utils.spliceDateFormat = function (date) {
        return (
            parseInt(String(date).slice(4, 6)) +
            "月" +
            parseInt(String(date).slice(6, 8)) +
            "日"
        );
    };
    // 特殊时间格式化 570 => 09:30:00
    utils.speTimeFormat = function (time) {
        time = parseInt(time);
        let hour = parseInt(time / 60);
        let minute = time % 60;
        hour = hour < 10 ? "0" + hour : "" + hour;
        minute = minute < 10 ? "0" + minute : "" + minute;
        return hour + ":" + minute + ":00";
    };

    /**
     * 判断是否显示高手头像icon可点击提示
     */
    utils.checkShowIconBubble = function (bubble_id, uid) {
        var icon_bubble = localStorage.getItem(bubble_id);
        if (!icon_bubble) {
            $("#" + bubble_id).removeClass("none");
            icon_bubble = {};
            icon_bubble[uid] = 1;
            localStorage.setItem(bubble_id, JSON.stringify(icon_bubble));
        } else {
            icon_bubble = JSON.parse(icon_bubble);
            if (!icon_bubble[uid]) {
                $("#" + bubble_id).removeClass("none");
                icon_bubble[uid] = 1;
                localStorage.setItem(bubble_id, JSON.stringify(icon_bubble));
            }
        }
        // 简单判断
        // if(!localStorage.getItem(bubble_id)) {
        //     $('#' + bubble_id).removeClass('none');
        //     localStorage.setItem('icon_bubble', 1);
        // }
    };

    /**
     * 格式化点赞数和评论数
     */
    utils.formatCount = function (count) {
        return count > 999 ? "999+" : count;
    };

    //= ========================================call方法调用用以处理与终端顶部交互============================================
    /**
     * 滚动触发顶部菜单显示和隐藏
     * @param mescroll
     * @param y mescroll的scrollTop
     * @param up=true向上滑,up=false向下滑
     */
    utils.scrollNativeHeader = function (mescroll, y, up) {
        if (up) {
            if (y >= this.headerShowY) {
                if (this.headerShowStatus === 0 && this.isGNN) {
                    if (this.detailData.tgInfo.followStatus === 1) {
                        utils.setNativeMenu([this.headerMenu["3"]]);
                    } else {
                        utils.setNativeMenu([this.headerMenu["2"]]);
                    }
                    utils.setNativeTitle(this.headerTitle["1"]);
                    this.headerShowStatus = 1;
                }
            }
        } else {
            if (y < this.headerShowY) {
                if (this.headerShowStatus === 1) {
                    utils.setNativeMenu([]);
                    utils.setNativeTitle(this.headerTitle["0"]);
                    this.headerShowStatus = 0;
                }
            }
        }
    };

    /**
     * 在终端顶部切换关注状态
     */
    utils.nativeHeaderChangeFollow = function () {
        if (this.mescroll.getScrollTop() >= this.headerShowY) {
            if (this.detailData.tgInfo.followStatus) {
                utils.setNativeMenu([this.headerMenu["2"]]);
            } else {
                utils.setNativeMenu([this.headerMenu["3"]]);
            }
        }
    };

    /**
     * 绑定需要判断需要校验登录态的事件
     * @param type
     * 0:问股
     * 2:关注
     * 4:评论
     * 5:点赞
     * 6:分享
     */
    utils.bindCheckLoginClick = function (type, extro) {
        var that = this;
        // 终端校验是否登录
        upNativeComm.exec("UPUser.getUserInfo", {
            callback: function (code, user) {
                user = JSON.parse(user);
                if (user.uid && !user.isTourist) {
                    that.bindCtrlClick(type, extro);
                } else {
                    utils.openUserLogin();
                }
            },
        });
    };
    /**
     * 绑定需要判断需要校验登录态的事件
     * @param type
     * 0:问股
     * 2:关注
     * 4:评论
     * 5:点赞
     * 6:分享
     */
    utils.bindCheckTouristLoginClick = function (type, extro) {
        var that = this;
        // 终端校验是否登录
        upNativeComm.exec("UPUser.getUserInfo", {
            callback: function (code, user) {
                user = JSON.parse(user);
                if (user.uid) {
                    that.bindCtrlClick(type, extro);
                } else {
                    utils.openUserLogin();
                }
            },
        });
    };
    utils.bindLoginClick = function (type, extro) {
        var that = this;
        // 终端校验是否登录
        upNativeComm.exec("UPUser.getUserInfo", {
            callback: function (code, user) {
                user = JSON.parse(user);
                if (user.uid) {
                    that.bindClick(type, extro);
                } else {
                    utils.openUserLogin();
                }
            },
        });
    };
    /**
     * 终端顶部有关注按钮
     * @param status
     */
    utils.headerCanFollow = function (status) {
        var opt = {
            status: status,
            tgUpName: this.detailData.tgInfo.tgUpName,
        };
        var that = this;
        utils.ajaxRequest({
            url: "/followTg",
            data: opt,
            succCallback: function (data) {
                if (data.ret === 0) {
                    if (that.detailData.tgInfo.followStatus) {
                        that.followPop.show = false;
                        utils.showToast({ content: "取消关注成功" });
                    } else {
                        utils.showToast({ content: "关注成功" });
                    }
                    utils.nativeHeaderChangeFollow.call(that);
                    that.detailData.tgInfo.followStatus = Math.abs(
                        that.detailData.tgInfo.followStatus - 1
                    );
                } else {
                    utils.showToast({ content: data.message });
                }
            },
            errCallback: function (xhr, stat, err) {
                utils.showToast({ content: "请求超时" });
            },
        });
    };

    /*
     ** 去掉后缀带有?tp=webp的图片，
     ** alist:列表数组
     ** imgname:列表中的图片列表的名称
     */
    utils.filterImgs = function (alist, imgname) {
        for (let i = 0; i < alist.length; i++) {
            if (alist[i][imgname].length > 0) {
                for (let j = 0; j < alist[i][imgname].length; j++) {
                    alist[i][imgname][j] = alist[i][imgname][j].replace(
                        "?tp=webp",
                        ""
                    );
                }
            }
        }
        return alist;
    };

    utils.dateFormat2 = function (fmt, date) {
        let ret;
        const opt = {
            "Y+": date.getFullYear().toString(), // 年
            "m+": (date.getMonth() + 1).toString(), // 月
            "d+": date.getDate().toString(), // 日
            "H+": date.getHours().toString(), // 时
            "M+": date.getMinutes().toString(), // 分
            "S+": date.getSeconds().toString(), // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                // fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                fmt = fmt.replace(ret[1], opt[k] >= 10 ? opt[k] : "0" + opt[k]);
            }
        }
        return fmt;
    };
    //倒计时
    utils.countdown = function (options) {
        var options = concat({}, options || {});

        var timeStart = Date.parse(options.timeStart.replace(/-/g, "/")),
            timeEnd = Date.parse(options.timeEnd.replace(/-/g, "/")),
            funBefore = options.funBefore,
            funBetween = options.funBetween,
            funAfter = options.funAfter;

        // Init
        timer();

        function concat(objA, objB) {
            // 合并
            if (objA && objB) {
                for (var key in objB) {
                    objA[key] = objB[key];
                }
            }
            return objA;
        }

        function timer() {
            // 计时器
            var timeNow = new Date().getTime();
            timeStart = new Date(timeStart).getTime();
            timeEnd = new Date(timeEnd).getTime();

            if (timeEnd - timeStart < 0) {
                return setTimeout(timer, 1000 / 60);
            }

            if (timeNow < timeStart) {
                if (typeof funBefore === "function") {
                    funBefore(format(timeStart - timeNow));
                }
                return setTimeout(timer, 1000 / 60);
            }

            if (timeNow > timeEnd) {
                if (typeof funAfter === "function") {
                    funAfter(format(timeNow - timeEnd));
                }
                return setTimeout(timer, 1000 / 60);
            }

            if (typeof funBetween === "function") {
                funBetween(format(timeEnd - timeNow));
            }

            setTimeout(timer, 1000 / 60);
        }

        function format(data) {
            // 数据格式化

            var result;

            // 剩余天数
            var dataDay = Math.floor(data / (24 * 60 * 60 * 1000));

            // 剩余小时数
            data = data - dataDay * 24 * 60 * 60 * 1000;
            var dataHour = Math.floor(data / (60 * 60 * 1000));

            // 剩余分钟数
            data = data - dataHour * 60 * 60 * 1000;
            var dataMinute = Math.floor(data / (60 * 1000));

            // 剩余秒数
            data = data - dataMinute * 60 * 1000;
            var dataSecond = Math.floor(data / 1000);

            // 剩余毫秒数
            data = data - dataSecond * 1000;
            var dataMilliSecond = Math.floor(data / 10);

            result = {
                day: convertLen(dataDay),
                hour: convertLen(dataHour),
                minute: convertLen(dataMinute),
                second: convertLen(dataSecond),
                millisecond: convertLen(dataMilliSecond),
            };
            return result;
        }

        function convertLen(data) {
            return data < 10 ? "0" + data : data;
        }
    };

    /**
     * 进入直播 此方法废弃
     */
    utils.setEnterVideoLive = function (videoLiveOpt) {
        videoLiveOpt = videoLiveOpt || {
            h5Url: "",
            videoUrl: "",
        };
        upNativeComm["exec"]("Navigation.h5VideoEnter", videoLiveOpt);
    };

    /**
     * 直播结束 此方法废弃
     */
    utils.setEndVideoLive = function (videoLiveOpt) {
        upNativeComm["exec"]("Navigation.h5VideoEnd", videoLiveOpt);
    };

    /**
     * 关闭小窗播放
     */
    utils.stopWindowPlay = function (videoLiveOpt) {
        upNativeComm["exec"]("Ext.stopWindowPlay");
    };

    /**
     * 开启小窗播放
     * videoLiveOpt = {
     *  h5Url:h5地址
     *  videoUrl:播放url
     *  startTime:时间点 //录播有开始时间，没有结束时间
     *  endTime:结束时间 //直播有结束时间，没有startTime
     * }
     */
    utils.startWindowPlay = function (videoLiveOpt, cb) {
        videoLiveOpt.videoUrl = videoLiveOpt.liveVidoeUrl;
        upNativeComm["exec"]("Navigation.startWindowPlay", {
            videoUrl: videoLiveOpt.liveVidoeUrl,
            h5Url: videoLiveOpt.h5Url,
            startTime: videoLiveOpt.startTime,
            endTime: videoLiveOpt.endTime,
            callback:
                cb ||
                function (code, ret) {
                    ret = JSON.parse(ret);
                    if (ret.ret == 0) {
                        upNativeComm.exec("WebView.close");
                    }
                },
        });
    };

    utils.setCookies = function (key, val, path, domain) {
        if (/^(?:expires|max-age|path|domain)$/i.test(key) === false) {
            var _option = {};
            var _key = encodeURIComponent(key);
            _option[_key] = encodeURIComponent(val);
            _option.path = path || location.pathname;
            _option.domain = domain || location.hostname;
            var domainList = Object.keys(_option).map(function (key) {
                var val = _option[key];
                if (val === "undefined") {
                    val = "";
                }
                return key + "=" + val;
            });
            document.cookie = domainList.join(";");
        }
    };

    utils.debounce = function (fn, delay = 300) {
        let _timer = null;

        return function () {
            if (_timer) {
                clearTimeout(_timer);
            }

            const ctx = this;
            _timer = setTimeout(() => {
                fn.apply(ctx, arguments);
            }, delay);
        };
    };

    utils.throttle = function (fn, interval = 300) {
        let _timer = null;

        return function () {
            if (_timer) {
                return;
            }

            const ctx = this;
            _timer = setTimeout(() => {
                fn.apply(ctx, arguments);

                _timer = null;
            }, interval);
        };
    };

    //解析路径参数
    utils.parseQueryString = function (str) {
        var reg = /([^?&#=]+)=([^?&#=]+)/g;
        var obj = {};
        str.replace(reg, function () {
            obj[arguments[1]] = arguments[2];
        });
        return obj;
    };

    // 查看大图，兼容网页与终端两种查看方式
    utils.showImg = function (option = {}) {
        const url = option.url || imageList[index] || "";
        const imageList = option.imageList || [url];
        const index = option.index || 1;

        if (utils.isApp) {
            upNativeComm.exec("Media.viewImage", { imageList, index, url });
        } else {
            utils.picLook(url);
        }
    };

    // 纯网页查看图片
    const picLook = `<div class="picLook">
        <div class="plImg">
            <img src="">
        </div>
    </div>`;
    let isImgLookMounted = false;
    utils.picLook = function (imgurl) {
        !isImgLookMounted && $("body").append($(picLook));
        $(".picLook").show();
        $(".picLook img").attr("src", imgurl);
        isImgLookMounted = true;
        $(".picLook").click(function () {
            $(".picLook").hide();
        });
    };

    // 监听网络变化
    utils.watchNetwork = function (cb) {
        cb =
            cb ||
            function (onLine) {
                if (!onLine) {
                    utils.showToast({ content: "网络开小差了" });
                }
            };

        setInterval(() => {
            $.ajax({
                type: "GET",
                url: `${window.staticSourceCdnPath}/dist/images/1px.txt`,
                success: (res) => {
                    cb(true);
                },
                error: function (err) {
                    if (err.readyState === 0 || err.status === 0) {
                        cb(false);
                    }
                },
            });
        }, 30000);
    };

    // 兼容终端与h5的跳转
    utils.openUrl = function (url) {
        if (utils.isApp) {
            upNativeComm.exec("WebView.open", {
                url,
            });
        } else {
            window.location.href = url;
        }
    };
    // 不新开webview跳转
    utils.openHref = function (url) {
        window.location.href = url;
    }
    /**
     * 获取 blob
     * @param  {String} url 目标文件地址
     * @return {Promise}
     */
    utils.getBlob = function (url) {
        return new Promise((resolve) => {
            const xhr = new XMLHttpRequest();

            xhr.open("GET", url, true);
            xhr.responseType = "blob";
            xhr.onload = () => {
                if (xhr.status === 200) {
                    resolve(xhr.response);
                }
            };

            xhr.send();
        });
    };

    /**
     * 保存
     * @param  {Blob} blob
     * @param  {String} filename 想要保存的文件名称
     */
    utils.saveAs = function (blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement("a");
            const body = document.querySelector("body");

            link.href = window.URL.createObjectURL(blob);
            link.download = filename;

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);

            window.URL.revokeObjectURL(link.href);
        }
    };

    /**
     * 下载
     * @param  {String} url 目标文件地址
     * @param  {String} filename 想要保存的文件名称
     */
    utils.download = function (url, filename) {
        if (utils.isApp) {
            upNativeComm.exec("Media.saveImage", { url });
            utils.showToast({ content: "保存成功" });
        } else {
            window.open(url, "_blank");
        }
    };

    /**
     * @description:
     * @param {*} url
     * @return {*}
     */
    utils.saveB64Img = function (url) {
        url = url.slice(22)
        let num = 0;
        if (url.length % 1000 === 0) {
            num = url.length / 1000
        }
        else {
            num = parseInt(url.length / 1000) + 1;
        }
        upNativeComm.exec('Media.saveBase64Image', { status: 1, fileName: 'mindMap.png', data: '' })
        for (let i = 0; i < num; i++) {
            let value = url.slice((i * 1000), (i + 1) * 1000);
            upNativeComm.exec('Media.saveBase64Image', { status: 2, fileName: 'mindMap.png', data: value })
        }
        upNativeComm.exec('Media.saveBase64Image', { status: 3, fileName: 'mindMap.png', data: '' })
        utils.showToast({ content: '保存成功' })
    }
    /**
     * 安全base64编码.
     */
    utils.urlSafeBase64Encode = function (str) {
        const base64Str = base64url_encode(str);

        return base64Str
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/\=/g, "");
    };

    /**
     * 安全base64解码.
     */
    utils.urlSafeBase64Decode = function (str) {
        const res = str.replace(/-/g, "+").replace(/_/g, "\\");
        return window.atob(res);
    };

    /**
     * 在终端设置小窗自动播放.
     */
    utils.setAutoPlay = function (params = {}) {
        const options = Object.assign(
            {
                switch: 1,
            },
            params
        );

        if (utils.isApp) {
            upNativeComm.exec("Ext.setAutoPlay", options);
        }
    };
    function isIOSVersionGreaterThan16() {
        const userAgent = window.navigator.userAgent;
        const iosVersionMatch = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
    
        if (iosVersionMatch) {
            const majorVersion = parseInt(iosVersionMatch[1], 10);
            return majorVersion > 16;
        }
    
        return false;
    };


    /**
     * 更新视频播放进度.
     */
    utils.updateVideoProgress = function (progress = 0) {
        if (utils.isApp) {
             // iosi7 调用会暂停回放
             console.log('ios系统大于16：',isIOSVersionGreaterThan16());
            //  if (isIOSVersionGreaterThan16()) {
                var _ups = new UPContent();
                _ups.Set('progress', progress);
                Up_Callback('', 'updateVideoProgress', _ups, '', 'LOC');
            //  } else {
            //      upNativeComm.exec("Ext.updateVideoProgress", { progress });
            //  }
        }
    };

    utils.checkRisk = (options = {}) => {
        options = Object.assign({
            allowTour: true
        }, options)

        let moduleIds = (options.rightId || '').trim().split('|')
        if (moduleIds.length == 0) {
            moduleIds = [2116, 6117];
        }
        if (utils.isApp) {
            window.upNativeComm.exec('UPUser.getUserInfo', {
                callback: (code, user) => {
                    user = user ? JSON.parse(user) : null

                    // 没有登录
                    if (!user || !user.uid) {
                        return
                    }

                    // 不允许游客
                    if (!options.allowTour && user.isTourist) {
                        return
                    }

                    window.windTestApi.init({
                        moduleIds: moduleIds,
                        platfrom: 'app',
                        appToken: encodeURIComponent(user.token),
                        appSign: encodeURIComponent(user.sign),
                        env: window.riskEnv
                    })
                }
            })
        } else {
            window.windTestApi.init({
                moduleIds: moduleIds,
                platfrom: 'h5',
                env: window.riskEnv
            })
        }
    }

    window.utils = utils;
})(window.Zepto, window.upNativeComm, window.dayjs);
